import { createAsyncThunk } from '@reduxjs/toolkit'
import { makeFetchSlice, fetchHomeDataThunk } from 'app/redux-fetch'
import {
  purchaseSubscription,
  previewSubscription,
  PurchaseSubscriptionParams,
} from 'features/home/api'
import { fetchHomeThunk } from 'features/home/slice'
import { fetchSubscriptionsThunk } from '../../slice'

const purchaseSubscriptionSlice = makeFetchSlice('purchaseSubscription')

export const purchaseSubscriptionReducer = purchaseSubscriptionSlice.reducer
export const purchaseSubscriptionActions = purchaseSubscriptionSlice.actions

export const purchaseSubscriptionThunk = createAsyncThunk<
  any,
  PurchaseSubscriptionParams
>('subscription/purchase', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await fetchHomeDataThunk({
      dispatch,
      actions: purchaseSubscriptionActions,
      asyncFunc: () => purchaseSubscription(params),
    })
    await dispatch(fetchSubscriptionsThunk(params.homeId))
    await dispatch(fetchHomeThunk(params.homeId))
    return response
  } catch (error: any) {
    if (error?.response) {
      throw rejectWithValue(error?.response.data)
    }
    console.log('Error purchasing subscription', error)
    throw error
  }
})

const previewSubscriptionSlice = makeFetchSlice('previewSubscription')

export const previewSubscriptionReducer = previewSubscriptionSlice.reducer
export const previewSubscriptionActions = previewSubscriptionSlice.actions

export const previewSubscriptionThunk = createAsyncThunk<
  any,
  PurchaseSubscriptionParams
>('subscription/purchase', async (params, { dispatch, rejectWithValue }) => {
  try {
    const response = await fetchHomeDataThunk({
      dispatch,
      actions: previewSubscriptionActions,
      asyncFunc: () => previewSubscription(params),
    })
    return response
  } catch (error: any) {
    if (error?.response) {
      throw rejectWithValue(error?.response.data)
    }
    console.log('Error previewing subscription', error)
    throw error
  }
})
